<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.5833 14.1664H18.3333V4.99969C18.3333 4.08051 17.5859 3.33301 16.6666 3.33301H3.33332C2.41414 3.33301 1.66664 4.08047 1.66664 4.99969V14.1664H0.416641C0.186367 14.1664 0 14.3527 0 14.583V14.9997C0 15.9189 0.747461 16.6664 1.66668 16.6664H18.3334C19.2525 16.6664 20 15.9189 20 14.9997V14.583C20 14.3527 19.8136 14.1664 19.5833 14.1664ZM2.5 4.99969C2.5 4.54031 2.87395 4.16637 3.33332 4.16637H16.6666C17.126 4.16637 17.5 4.54031 17.5 4.99969V14.1664H2.5V4.99969ZM18.3333 15.833H1.66668C1.2073 15.833 0.833359 15.4591 0.833359 14.9997H7.74414L8.03875 15.2943C8.11688 15.3724 8.22266 15.4164 8.33336 15.4164H11.6667C11.7773 15.4164 11.8832 15.3724 11.9613 15.2943L12.2559 14.9997H19.1667C19.1667 15.4591 18.7927 15.833 18.3333 15.833Z"
      fill="#153D49"
    />
  </svg>
</template>
